import { Button, Modal } from 'antd'
import { useEffect, useState } from 'react'
import config from '../../config'
import {
  CarRequestResponse,
  getCarRequestById,
} from '../../services/car-request/car-request.service'

interface CarRentalLoginVariantProps {
  carIconUrl?: string
  requestId?: string
  onLoginClick?: () => void
  minEarnings?: number
  maxEarnings?: number
}

const CarRentalLoginVariant = ({
  carIconUrl,
  requestId,
  onLoginClick,
  minEarnings = 25000,
  maxEarnings = 100000,
}: CarRentalLoginVariantProps) => {
  const [isWhyLoginModalVisible, setIsWhyLoginModalVisible] = useState(false)
  const [carRequest, setCarRequest] = useState<CarRequestResponse | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchCarRequest = async () => {
      if (requestId) {
        setLoading(true)
        const data = await getCarRequestById(requestId)
        setCarRequest(data)
        setLoading(false)
      } else {
        setLoading(false)
      }
    }

    fetchCarRequest()
  }, [requestId])

  const handleLineLogin = () => {
    const state = Math.random().toString(36).substring(2, 15)
    const nonce = Math.random().toString(36).substring(2, 15) + Date.now()
    const lineAuthUrl = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${
      config.social.LINE_LOGIN_ID
    }&redirect_uri=${encodeURIComponent(
      config.social.LINE_CALLBACK_URL,
    )}&state=${state}&scope=profile openid email&nonce=${nonce}&bot_prompt=normal`
    window.location.href = lineAuthUrl
  }

  const handleEmailLogin = () => {
    onLoginClick?.()
  }

  const getRenterDisplayData = (fullName = '') => {
    const firstName = fullName.trim().split(' ')[0] || 'User'
    const initial = firstName.charAt(0).toUpperCase()
    return { firstName, initial }
  }

  return (
    <>
      <div
        style={{
          backgroundColor: '#fff',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
        }}
      >
        {/* Blue Background - extends from top to half of CTA card */}
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '70%',
            backgroundColor: '#E6F3FF',
            borderBottomLeftRadius: '24px',
            borderBottomRightRadius: '24px',
            zIndex: 0,
          }}
        />

        {/* Content wrapper */}
        <div
          style={{
            position: 'relative',
            zIndex: 1,
            padding: '24px',
            paddingBottom: '48px',
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
          }}
        >
          {/* Header Section */}
          <div style={{ marginBottom: '24px' }}>
            <h1
              style={{
                fontSize: '20px',
                fontWeight: 600,
                color: '#212427',
                marginBottom: '16px',
              }}
            >
              รถของคุณเป็นที่ต้องการ!
            </h1>

            <div style={{ marginBottom: '12px' }}>
              <div
                style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}
              >
                <img
                  src="https://ts-upload.sgp1.digitaloceanspaces.com/cms/4St48PcSscZt2qB8RfY2eZmQxCwdnqxShp5bMgfbebq8zpwKaVpC45tRRtwkJw4oTgKCtUZevwBeHzKweC3aK83Q.png"
                  alt="Available"
                  style={{ width: '24px', height: '24px', flexShrink: 0 }}
                />
                <span style={{ fontSize: '14px', color: '#212427' }}>คำขอนี้ยังคงเปิดรับอยู่</span>
              </div>
              <div
                style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}
              >
                <img
                  src="https://ts-upload.sgp1.digitaloceanspaces.com/cms/41nhiuRAyFE6BagRLmpM41KdRuCSCzxuRoSsKnt7RHnj5Da9rYZJvbYRUYKhsCBiMWjTm9eTFaa381Xne8ws8z4T.png"
                  alt="Interest"
                  style={{ width: '24px', height: '24px', flexShrink: 0 }}
                />
                <span style={{ fontSize: '14px', color: '#212427' }}>
                  เจ้าของรถรายอื่นให้ความสนใจคำขอนี้แล้ว
                </span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <img
                  src="https://ts-upload.sgp1.digitaloceanspaces.com/cms/3mwtPTS27QumjgVBJTWot4HH1dJdJ48xeNPZCDSDRuSMUufU9yPxmCYLfMfKZUpjnTm5mu1nv7Qsk5n5mWmWsKhA.png"
                  alt="Earnings"
                  style={{ width: '24px', height: '24px', flexShrink: 0 }}
                />
                <span style={{ fontSize: '14px', color: '#212427' }}>
                  รับคำขอนี้ เพื่อเริ่มต้นสร้างรายได้
                </span>
              </div>
            </div>
          </div>

          {/* Car Request Card - Only show if car request exists */}
          {carRequest && (
            <div
              style={{
                border: '1px solid #E5E7EB',
                borderRadius: '12px',
                padding: '20px',
                marginBottom: '24px',
                backgroundColor: '#fff',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
                {/* Car Icon */}
                {carIconUrl && (
                  <div
                    style={{
                      width: '105px',
                      height: '70px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <img
                      src={carIconUrl}
                      alt="Car"
                      style={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        objectFit: 'contain',
                      }}
                    />
                  </div>
                )}

                {/* Car Details */}
                <div style={{ flex: 1 }}>
                  <h2
                    style={{
                      fontSize: '18px',
                      fontWeight: 600,
                      color: '#212427',
                      marginBottom: '12px',
                    }}
                  >
                    {`${carRequest.preferred_brand || ''} ${carRequest.preferred_model || ''} ${
                      carRequest.car_information?.model_year &&
                      carRequest.car_information.model_year !== 'null'
                        ? carRequest.car_information.model_year
                        : ''
                    }`.trim()}
                  </h2>

                  <div style={{ marginBottom: '12px' }}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        marginBottom: '4px',
                      }}
                    >
                      <span style={{ fontSize: '14px', color: '#6B7280' }}>Requested by</span>
                      <div
                        style={{
                          width: '24px',
                          height: '24px',
                          backgroundColor: '#0048B3',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: '#fff',
                          fontSize: '12px',
                          fontWeight: 600,
                        }}
                      >
                        {getRenterDisplayData(carRequest.renter_name).initial}
                      </div>
                    </div>
                    {carRequest.car_information?.pickup_date &&
                      (carRequest.car_information?.drop_off_date ||
                        (carRequest.car_information?.duration &&
                          carRequest.car_information?.duration_type)) && (
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            marginBottom: '4px',
                          }}
                        >
                          <img
                            src="https://ts-upload.sgp1.digitaloceanspaces.com/cms/2cc64LVE45RgyDvsf4AFjjKnVmwVCsnfgCYQMZqHQ2r61sJXzZjowhGit6qSKn5zvdYWDU2tCemPbzhUTLWMJuuL.png"
                            alt="Calendar"
                            style={{ width: '16px', height: '16px', flexShrink: 0 }}
                          />
                          <span style={{ fontSize: '14px', color: '#212427' }}>
                            {(() => {
                              const startDate = new Date(carRequest.car_information.pickup_date!)

                              const formatDate = (date: Date) => {
                                const day = date.getDate()
                                const month = date.toLocaleString('en-US', { month: 'short' })
                                const year = date.getFullYear()
                                return `${day} ${month} ${year}`
                              }

                              // Check if drop_off_date exists in response
                              if (carRequest.car_information.drop_off_date) {
                                const endDate = new Date(carRequest.car_information.drop_off_date)
                                return `${formatDate(startDate)} ~ ${formatDate(endDate)}`
                              }

                              // Otherwise calculate it
                              const duration = parseInt(carRequest.car_information.duration!)
                              const durationType =
                                carRequest.car_information.duration_type?.toLowerCase()
                              const endDate = new Date(startDate)

                              if (durationType === 'month') {
                                endDate.setMonth(endDate.getMonth() + duration)
                              } else if (durationType === 'day') {
                                endDate.setDate(endDate.getDate() + duration)
                              }

                              return `${formatDate(startDate)} ~ ${formatDate(endDate)}`
                            })()}
                          </span>
                        </div>
                      )}
                    {carRequest.preferred_location && (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          marginBottom: '4px',
                        }}
                      >
                        <img
                          src="https://ts-upload.sgp1.digitaloceanspaces.com/cms/5L8dc8XQwu7koXBqZUHXoAGru2WTkee74ZpGixiKYNxxwrGvuTeng7fKrJkDDBShmopdLSi15ddWnNm7VC7dm1fD.png"
                          alt="Location"
                          style={{ width: '16px', height: '16px', flexShrink: 0 }}
                        />
                        <span style={{ fontSize: '14px', color: '#212427' }}>
                          {carRequest.preferred_location}
                        </span>
                      </div>
                    )}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <img
                        src="https://ts-upload.sgp1.digitaloceanspaces.com/cms/2H2US4Yuf9HhQLuYAE1tJe4uiKZJJF4ME4gPwn93LkuUoi5wM6adaW1PQ7jchYsQR7LMfjGJyMWCG3dZ1FioHSxq.png"
                        alt="Budget"
                        style={{ width: '16px', height: '16px', flexShrink: 0 }}
                      />
                      <span style={{ fontSize: '14px', color: '#212427' }}>
                        Budget :{' '}
                        {carRequest.car_information?.price_per_month
                          ? `${carRequest.car_information.currency || 'THB'} ${Number(
                              carRequest.car_information.price_per_month,
                            ).toLocaleString()}${
                              carRequest.car_information.duration_type
                                ? `/${
                                    carRequest.car_information.duration_type
                                      .charAt(0)
                                      .toUpperCase() +
                                    carRequest.car_information.duration_type.slice(1)
                                  }`
                                : ''
                            }`
                          : 'Not specified'}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* CTA and Login Section Combined */}
          <div
            style={{
              backgroundColor: '#fff',
              borderRadius: '12px',
              padding: '20px',
              paddingBottom: '24px',
              marginBottom: '40px',
              boxShadow: '0px 4px 6px -2px #1018280D, 0px 12px 16px -4px #1018281A',
            }}
          >
            <h3
              style={{
                fontSize: '16px',
                fontWeight: 600,
                color: '#212427',
                marginBottom: '12px',
              }}
            >
              อย่าพลาดโอกาสนี้!
            </h3>
            <p
              style={{
                fontSize: '14px',
                color: '#6B7280',
                marginBottom: '16px',
                lineHeight: '1.5',
              }}
            >
              เข้าสู่ระบบหรือสมัครสมาชิกเพื่อแจ้งผู้เช่าเกี่ยวกับรถของคุณ ยืนยันการจอง
              และเริ่มสร้างรายได้วันนี้
            </p>
            <a
              onClick={() => setIsWhyLoginModalVisible(true)}
              style={{
                fontSize: '14px',
                color: '#0048B3',
                cursor: 'pointer',
                textDecoration: 'none',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '4px',
                marginBottom: '20px',
              }}
            >
              ทำไมฉันต้องเข้าสู่ระบบ? <span>›</span>
            </a>

            {/* Action Buttons */}
            <div style={{ marginTop: '20px' }}>
              <Button
                block
                type="primary"
                size="large"
                onClick={handleLineLogin}
                style={{
                  height: '60px',
                  backgroundColor: '#06C755',
                  borderColor: '#06C755',
                  borderRadius: '12px',
                  fontSize: '16px',
                  fontWeight: 500,
                  marginBottom: '16px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '12px',
                }}
              >
                <img
                  src="https://ts-upload.sgp1.digitaloceanspaces.com/cms/2bkc38bGtiA2rbdewHrR2GHa9xbQwoBg6VDWPAFxyUUpFVxVTy8UHWjt96chwgs5AM1sZ29qG6u8aAeVo4DxUu9z.png"
                  alt="LINE"
                  style={{ width: '32px', height: '32px' }}
                />
                <div
                  style={{
                    height: '32px',
                    width: '1px',
                    backgroundColor: '#FFFFFF',
                    opacity: 0.5,
                  }}
                />
                Log in or register with LINE
              </Button>

              <div
                style={{
                  textAlign: 'center',
                  color: '#667085',
                  fontSize: '14px',
                  marginBottom: '12px',
                }}
              >
                Or log in with email or others
              </div>

              <div style={{ textAlign: 'center' }}>
                <a
                  onClick={handleEmailLogin}
                  style={{
                    color: '#0048B3',
                    fontSize: '16px',
                    fontWeight: 500,
                    cursor: 'pointer',
                    textDecoration: 'underline',
                  }}
                >
                  Login
                </a>
              </div>
            </div>
          </div>

          {/* Extra spacing at bottom */}
          <div style={{ height: '40px' }} />
        </div>
      </div>

      {/* Why Login Modal */}
      <Modal
        open={isWhyLoginModalVisible}
        onCancel={() => setIsWhyLoginModalVisible(false)}
        footer={null}
        closable={true}
        width={490}
        centered
        style={{ borderRadius: '16px' }}
      >
        <div style={{ padding: '24px 0' }}>
          <h2
            style={{
              fontSize: '24px',
              fontWeight: 600,
              color: '#212427',
              marginBottom: '16px',
            }}
          >
            ทำไมฉันต้องเข้าสู่ระบบ?
          </h2>
          <p
            style={{
              fontSize: '14px',
              color: '#6B7280',
              marginBottom: '24px',
              lineHeight: '1.6',
            }}
          >
            เราต้องการให้คุณเข้าสู่ระบบเพื่อส่งข้อมูลรถของคุณอย่างปลอดภัย ซึ่งช่วยให้เรา:
          </p>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div
                style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '50%',
                  backgroundColor: '#F4F5F9',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}
              >
                <img
                  src="https://ts-upload.sgp1.digitaloceanspaces.com/cms/3Puww9iPnvAjQKRju95toiYYZsEwdxCj5dT6Cq5K3tyY7vmSjE6TBpULgsncXRvxn1Xf59RnbmaHRyGH54FtBjhk.png"
                  alt="Verify"
                  style={{ width: '24px', height: '24px' }}
                />
              </div>
              <p
                style={{
                  fontSize: '14px',
                  color: '#212427',
                  margin: 0,
                  lineHeight: '1.5',
                }}
              >
                ยืนยันตัวตนของคุณและป้องกันการส่งข้อมูลที่ไม่พึงประสงค์
              </p>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div
                style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '50%',
                  backgroundColor: '#F4F5F9',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}
              >
                <img
                  src="https://ts-upload.sgp1.digitaloceanspaces.com/cms/63m6D86ozLwWsh3aRdgw3Ddn9PqTdCMmEhUtHLUd5uuKNTzbu7pTBDmJsD2jbLE3zFfEPDFF97Yv7mEDU8KYgqhG.png"
                  alt="Match"
                  style={{ width: '24px', height: '24px' }}
                />
              </div>
              <p
                style={{
                  fontSize: '14px',
                  color: '#212427',
                  margin: 0,
                  lineHeight: '1.5',
                }}
              >
                จับคู่ข้อมูลที่ส่งกับบัญชีของคุณเพื่อรับการตอบกลับจากผู้เช่าในอนาคต
              </p>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div
                style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '50%',
                  backgroundColor: '#F4F5F9',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}
              >
                <img
                  src="https://ts-upload.sgp1.digitaloceanspaces.com/cms/2TGdVE6txkZaz3dhf9X6axiZEQ8d5gNnbBqN8CB7njLJMCfBEgND999cQUaLuaSzZtVNgtbaJfssdURy3tHh7PSF.png"
                  alt="Notify"
                  style={{ width: '24px', height: '24px' }}
                />
              </div>
              <p
                style={{
                  fontSize: '14px',
                  color: '#212427',
                  margin: 0,
                  lineHeight: '1.5',
                }}
              >
                แจ้งเตือนคุณเมื่อผู้เช่าสนใจรถของคุณ
              </p>
            </div>
          </div>

          <p
            style={{
              fontSize: '14px',
              color: '#6B7280',
              marginTop: '24px',
              lineHeight: '1.6',
            }}
          >
            การเข้าสู่ระบบใช้เวลาเพียงไม่กี่วินาที และช่วยให้การส่งข้อมูลรถของคุณปลอดภัย
          </p>
        </div>
      </Modal>
    </>
  )
}

export default CarRentalLoginVariant
